<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div v-if="Object.keys(validation_errors).length !== 0"
           class="alert alert-danger alert-dismissible fade show" role="alert">
                    <span v-for="(err, index) in validation_errors" :key="index">
                      {{ err[0] }} <br />
                    </span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <form role="form" action="" enctype="multipart/form-data" files="true">
            <div class="form-row">
              <div class="col-md-6">
                <label for="file">Village Import <span class="c-required">* Import file must be xlsx, xls, csv format.</span></label>
                <input type="file" v-validate="'required'"  id="file" name="file" class="form-control form-control-sm" ref="file" @change="getFile()" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"/>
                <div class="invalid-feedback">
                  Village Import is required
                </div>
              </div>
            </div>
            <div class="form-row mt-2">
              <button class="btn btn-success btn-sm" @click.prevent="upload">Upload</button>
            </div>

          </form>
        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";

export default {
  page: {
    title: "Village Import",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Village Import",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Village Import",
          active: true
        }
      ],
      validation_errors: {},
      file: ""
    };
  },

  mounted() {},
  methods: {
    getFile() {
      this.file = this.$refs.file.files[0];
      if (this.file.size > 3072000) {
        this.$bvToast.toast("File size not greater then 3 MB", {
          title: "Error",
          autoHideDelay: 5000,
          variant: "error"
        });
        this.file = "";
      }
    },
    upload(){
      let formData = new FormData();
      formData.append("file", this.file);
      this.$validator.validate().then(valid => {
        if (valid) {
          http.post("api/villageImport/" , formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              "Content-type": "application/json"
            }
          }).then(response => {
            this.$bvToast.toast(response.data.message, {
              title: "Success",
              autoHideDelay: 5000,
              variant: "success"
            });
            this.file = ""
          }).catch(error => {
            this.validation_errors = error.response.data.errors;
          })
        }
      });
    }
  },
};
</script>
